import React, { ReactNode } from "react";
import { Modal, Typography } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "../mythModal/mythModal.less";
import "./passModal.less";
import "./resultModal.less";
const { Title } = Typography

// <CheckOutlined /> <CloseOutlined />
interface IProps {
  success: boolean
  hideTitle?:boolean
  text?: ReactNode
  title?: ReactNode
  content?: ReactNode
  width?: string
  visible: boolean
  onCancel?: (e: React.MouseEvent<HTMLElement>) => void
  footer?: ReactNode,
  onOk?: (e: React.MouseEvent<HTMLElement>) => void
}
export const ResultModal = ({ success,hideTitle, title, content, width, footer, visible, onCancel, onOk, text }: IProps) => {
  let icon = success ? <span className="icon-success"><CheckOutlined /></span> : <span className="icon-fail"><CloseOutlined /></span>;
  return <Modal
    className={`myth-modal result-modal`}
    width={width || '350px'}
    title={hideTitle?"":<Title level={4} style={{ marginBottom: 0 }}>{title || "Prompt"}</Title>}
    centered
    visible={visible}
    closable={true}
    onCancel={onCancel}
    onOk={onOk}
    footer={footer || null}
  >
    <div className="flex-col content">
      <div className="flex-row content">
        <div>{icon}</div>
        {/* {success ? <p style={{ marginLeft: '20px' }}>Congratulations! < br /> Minted successfully!</p> : <p style={{ marginLeft: '20px' }}>Minting failed <br /> Please try again</p>} */}
        <p style={{ marginLeft: '20px' }}>{text}</p>
      </div>
      {success ? <div style={{ marginTop: '40px' }}>{content}</div> : ''}
      {/* {onOk && <Button onClick={onOk}>Ok</Button>} */}
    </div>
  </Modal >
}
